import { useSelector } from "react-redux";

const useLogin = () => {
  const loginData = useSelector((state) => state.login);
  const { loginDetail } = loginData || {};

  return {
    loginDetail
  };
};
export default useLogin;
